import { Component } from '@angular/core';

@Component({
    selector: 'app-espace-client',
    templateUrl: './espace-client.component.html',
    styleUrls: ['./espace-client.component.css'],
    standalone: false
})
export class EspaceClientComponent {

}
